/**
 * Logo Carousel Block
 */
import Swiper from "swiper";
import { A11y, Autoplay, Keyboard } from "swiper/modules";
import { initializeOnApproach } from "../../../resources/js/_initialize-on-approach";

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".logo-carousel").forEach((carousel) => {
    initializeOnApproach(carousel, () => initializeLogoCarousel(carousel));
  });
});

document.addEventListener("blockEditorInit", function (event) {
  const block = event.detail.block;

  if (!block) {
    return;
  }

  if (block.matches && block.matches(".logo-carousel")) {
    initializeLogoCarousel(block);
  }

  block.querySelectorAll(".logo-carousel").forEach((carousel) => {
    initializeLogoCarousel(carousel);
  });
});

function initializeLogoCarousel(carouselElement) {
  const swiperContainer = carouselElement.querySelector(".logo-carousel__swiper");

  if (
    !swiperContainer ||
    swiperContainer.dataset.logoCarouselInitialized === "true"
  ) {
    return;
  }

  const slides = swiperContainer.querySelectorAll(".swiper-slide");

  swiperContainer.dataset.logoCarouselInitialized = "true";

  if (slides.length < 2) {
    carouselElement.classList.add("logo-carousel--locked");
    return;
  }

  const syncLockState = (swiperInstance) => {
    carouselElement.classList.toggle(
      "logo-carousel--locked",
      swiperInstance.isLocked,
    );
  };

  new Swiper(swiperContainer, {
    modules: [A11y, Autoplay, Keyboard],
    slidesPerView: 1,
    spaceBetween: 24,
    speed: 650,
    loop: slides.length > 1,
    watchOverflow: true,
    allowTouchMove: slides.length > 1,
    keyboard: {
      enabled: slides.length > 1,
      onlyInViewport: true,
    },
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: "Previous logos",
      nextSlideMessage: "Next logos",
    },
    on: {
      init() {
        syncLockState(this);
      },
      resize() {
        syncLockState(this);
      },
      lock() {
        syncLockState(this);
      },
      unlock() {
        syncLockState(this);
      },
    },
  });
}
